import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth'

// Get Firebase config from environment variable
const getFirebaseConfig = () => {
  const configString = import.meta.env.VITE_FIREBASE_CONFIG;
  
  if (!configString) {
    throw new Error('VITE_FIREBASE_CONFIG environment variable is not set');
  }
  
  try {
    return JSON.parse(configString);
  } catch (error) {
    throw new Error(`Failed to parse VITE_FIREBASE_CONFIG. It must be a valid JSON string. Error: ${error instanceof Error ? error.message : String(error)}`);
  }
};

const firebaseConfig = getFirebaseConfig();

export const provider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider('apple.com');
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);